import { brandInfo } from '@/mocks/brand';

export default function BrandAdvantages() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            为什么选择蜜芽
          </h2>
          <p className="text-foreground-600 text-sm mt-2">3000万妈妈的共同信赖</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {brandInfo.values.map((val) => (
            <div key={val.title} className="group p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${val.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{val.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{val.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
          {brandInfo.stats.map((stat) => (
            <div key={stat.label} className="text-center p-4">
              <p className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: "var(--font-heading)" }}>
                {stat.value}
              </p>
              <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}